var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.691 10.8025L24.9346 0.0574951H22.7442L14.7179 9.38721L8.30737 0.0574951H0.913574L10.6076 14.1657L0.913574 25.4334H3.10414L11.5801 15.5809L18.3501 25.4334H25.7439L15.6904 10.8025H15.691ZM12.6907 14.29L11.7085 12.8851L3.89344 1.70652H7.25802L13.5649 10.728L14.5471 12.1329L22.7452 23.8594H19.3806L12.6907 14.2905V14.29Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.ee2e8c0726568d69f2d4adafb99271ba.svg";
export { ForwardRef as ReactComponent };